import { transition, trigger, useAnimation } from '@angular/animations';
import { Component, inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {
  fadeInFromLeftAnimation,
  fadeOutToLeftAnimation,
  fadeInFromRightAnimation,
  fadeOutToRightAnimation,
} from '../../../../shared/animations/index';
import { UITheme } from '../../../../shared/definitions/ui-theme.enum';
import { ResetSimXUserPasswordRequest } from '../../../../shared/models/requests/reset-simx-user-password-request.model';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'reset-password',
  standalone: false,
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  host: {
    class: 'angular-component-wrapper',
  },
  encapsulation: ViewEncapsulation.None,
  animations: [
    trigger('fadeInFromLeftOutToLeftAnimation', [
      transition(':enter', [
        useAnimation(fadeInFromLeftAnimation, {
          params: {
            duration: '0.2s',
            delay: '0s',
          },
        }),
      ]),
      transition(':leave', [
        useAnimation(fadeOutToLeftAnimation, {
          params: {
            duration: '0.2s',
            delay: '0s',
          },
        }),
      ]),
    ]),
    trigger('fadeInFromRightOutToRightAnimation', [
      transition(':enter', [
        useAnimation(fadeInFromRightAnimation, {
          params: {
            duration: '0.2s',
            delay: '0s',
          },
        }),
      ]),
      transition(':leave', [
        useAnimation(fadeOutToRightAnimation, {
          params: {
            duration: '0.2s',
            delay: '0s',
          },
        }),
      ]),
    ]),
  ],
})
export class ResetPasswordComponent implements OnInit {
  private readonly _authenticationService = inject(AuthenticationService);
  private readonly _formBuilder = inject(FormBuilder);

  resetPasswordForm: FormGroup;

  displayResetPasswordActionSuccessMessage: boolean = false;
  displayResetPasswordActionErrorMessage: boolean = false;
  resetPasswordActionInProgress: boolean = false;

  uiTheme = UITheme;

  ngOnInit(): void {
    this.initializeResetPasswordForm();
  }

  initializeResetPasswordForm(): void {
    this.resetPasswordForm = this._formBuilder.group({
      email: ['', Validators.required],
    });
  }

  onResetPasswordFormSubmit(): void {
    this.resetPasswordActionInProgress = true;
    this.displayResetPasswordActionSuccessMessage = false;
    this.displayResetPasswordActionErrorMessage = false;
    this.resetPasswordForm.disable();

    const requestData: ResetSimXUserPasswordRequest = {
      email: this.resetPasswordForm.controls.email.value,
    };

    this._authenticationService.resetUserPassword(requestData).subscribe({
      next: () => {
        this.resetPasswordActionInProgress = false;
        this.resetPasswordForm.enable();
        this.displayResetPasswordActionSuccessMessage = true;
      },
      error: error => {
        this.resetPasswordActionInProgress = false;
        this.resetPasswordForm.enable();
        if (error.status === 404) {
          // Display the success message even if user
          // was not found to prevent account phishing
          this.displayResetPasswordActionSuccessMessage = true;
        } else {
          this.displayResetPasswordActionErrorMessage = true;
        }
      },
    });
  }
}
